import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchInventoryItems } from 'src/backend/inventory';

export const INVENTORY_ITEMS_QUERY_KEY = ['inventory', 'items'];

export function useInventoryItems({
  enabled = true,
  status,
  archived,
  search,
  limit,
  offset,
  eligibleForDonation,
} = {}) {
  return useQuery({
    queryKey: [
      ...INVENTORY_ITEMS_QUERY_KEY,
      status,
      archived,
      search,
      limit,
      offset,
      eligibleForDonation,
    ],
    queryFn: () =>
      fetchInventoryItems({
        status,
        archived,
        search,
        limit,
        offset,
        eligibleForDonation,
      }),
    placeholderData: keepPreviousData,
    enabled,
    refetchOnWindowFocus: false,
  });
}
